<ng-container *ngIf="collapsible && hasCollapsedCharts()">
	<div class="collapsed-chart-tray">
		<ng-container *ngFor="let chartOption of chartOptionsList; let i = index">
			<button
				*ngIf="isCollapsed(i)"
				class="collapsed-chart-pill"
				type="button"
				(click)="toggleCollapsed(i)"
				[attr.aria-label]="'Expand ' + chartOption.options.title?.text">
				<span class="collapsed-pill-title">{{ chartOption.options.title?.text }}</span>
				<span class="collapsed-pill-subtitle" *ngIf="chartOption.options.subtitle?.text">
					{{ chartOption.options.subtitle?.text }}
				</span>
				<mat-icon>expand_more</mat-icon>
			</button>
		</ng-container>
	</div>
</ng-container>

<div class="chart-container">
	<ng-container *ngFor="let chartOption of chartOptionsList; let i = index">
		<div class="chart-card" *ngIf="!collapsible || !isCollapsed(i)" [ngClass]="chartOption.widthClass">
			<div class="chart-header">
				<div class="chart-title">{{ chartOption.options.title?.text }}</div>
				<button
					*ngIf="collapsible"
					type="button"
					class="collapse-toggle"
					mat-icon-button
					(click)="toggleCollapsed(i)"
					[attr.aria-expanded]="true"
					aria-label="Collapse chart"
					matTooltip="Collapse chart">
					<mat-icon>expand_less</mat-icon>
				</button>
			</div>
			<p class="title-border"></p>
			<div class="chart-subtitle-wrapper">
				<div class="chart-subtitle">{{ chartOption.options.subtitle?.text }}</div>
			</div>
			<highcharts-chart id="chart-container-{{ i }}" (chartInstance)="onChartInstance($event, i)"
				[Highcharts]="Highcharts" class="chart-list" [options]="chartOption.options">
			</highcharts-chart>
		</div>
	</ng-container>
</div>